import { Button, Tooltip } from "@fluentui/react-components";
import { MoneyOffRegular, MoneyOffFilled } from "@fluentui/react-icons";
import { HSpace } from "@greco/components/dist/components/utils";
import {
  Cell,
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
} from "@silevis/reactgrid";
import { HorizontalSpacer } from "components/styled";
import * as React from "react";

export interface PaymentOptionsCell extends Cell {
  type: "paymentoptions";
  link?: string;
  invalidateFn?: any;
  saveFn?: any;
  cancelFn?: any;
  resolvementSuggestFn?: any;
  clearFn?: any;
  rowId?: any;
  selectedCount?: any;
  clientId?: any;
  edited?: boolean;
  isDisabled?: boolean;
  isCleared?: boolean;
  selected?: boolean;
  highlighted?: boolean;
  t: any;
}

export class PaymentOptionsCellTemplate
  implements CellTemplate<PaymentOptionsCell>
{
  getCompatibleCell(
    uncertainCell: Uncertain<PaymentOptionsCell>
  ): Compatible<PaymentOptionsCell> {
    let link: string | undefined;
    let t: any;
    t = getCellProperty(uncertainCell, "t", "function");

    let invalidateFn: any;
    try {
      invalidateFn = getCellProperty(uncertainCell, "invalidateFn", "function");
    } catch {
      invalidateFn = undefined;
    }

    let selectedCount: any;

    try {
      selectedCount = getCellProperty(uncertainCell, "selectedCount", "number");
    } catch {
      selectedCount = undefined;
    }

    let rowId: any;

    try {
      rowId = getCellProperty(uncertainCell, "rowId", "number");
    } catch {
      rowId = undefined;
    }

    let isDisabled = true;
    try {
      isDisabled = getCellProperty(uncertainCell, "isDisabled", "boolean");
    } catch {
      isDisabled = false;
    }

    let isCleared = true;
    try {
      isCleared = getCellProperty(uncertainCell, "isCleared", "boolean");
    } catch {
      isCleared = false;
    }

    let edited = false;
    try {
      edited = getCellProperty(uncertainCell, "edited", "boolean");
    } catch {
      edited = false;
    }

    let selected = false;
    try {
      selected = getCellProperty(uncertainCell, "selected", "boolean");
    } catch {
      selected = false;
    }
    let highlighted: boolean | undefined;
    try {
      highlighted = getCellProperty(uncertainCell, "highlighted", "boolean");
    } catch {
      highlighted = false;
    }
    // let inputValue: string | undefined;
    // try {
    //   inputValue = getCellProperty(uncertainCell, "inputValue", "string");
    // } catch {
    //   inputValue = undefined;
    // }

    const text = link;
    return {
      ...uncertainCell,
      link,
      text,
      rowId,
      invalidateFn,
      value: NaN,
      isDisabled,
      isCleared,
      selectedCount,
      selected,
      highlighted,
      edited,
      t, // isOpen,
      // inputValue,
    };
  }

  getClassName(
    cell: Compatible<PaymentOptionsCell>,
    isInEditMode: boolean
  ): string {
    return (
      (cell.className ? cell.className : "") +
      (cell.selected ? " rg-selected" : "") +
      (cell.highlighted ? " highlighted-selected-row" : "")
    );
  }

  render(
    cell: Compatible<PaymentOptionsCell>,
    isInEditMode: boolean,
    onCellChanged: (
      cell: Compatible<PaymentOptionsCell>,
      commit: boolean
    ) => void
  ): React.ReactNode {
    return <OptionsCell cell={cell} />;
  }
}

interface DIProps {
  cell: Record<string, any>;
}

const OptionsCell: React.FC<DIProps> = ({ cell }) => {
  if (cell.isCleared) {
    return null;
  }
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      {cell.selected ? (
        <Tooltip
          content={
            cell.selectedCount > 1
              ? cell.t("pct.invalidatePayments.label")
              : cell.t("pct.invalidatePayment.label")
          }
          relationship="label"
        >
          <Button
            data-help="payments-row-invalidate"
            appearance="subtle"
            size="small"
            icon={
              cell.selectedCount > 1 ? <MoneyOffFilled /> : <MoneyOffRegular />
            }
            onClick={(e) => {
              cell.invalidateFn();
            }}
          ></Button>
        </Tooltip>
      ) : (
        <div
          style={{
            width: "24px",
            height: "24px",
            alignItems: "center",
            boxSizing: "border-box",
            display: "inline-flex",
            justifyContent: "center",
            textDecorationLine: "none",
            verticalAlign: "middle",
            margin: "0px",
            overflow: "hidden",
          }}
        />
      )}
    </div>
  );
};
